import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['item', 'button', 'content'];

  get header() {
    return document.querySelector('.site__header');
  }

  connect() {
    this.overrideScrollBehavior();
  }

  toggleCareerItem(event) {
    const button = event.currentTarget;
    const itemId = button.getAttribute('aria-controls');
    const content = this.element.querySelector(`#${itemId}`);
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', !isExpanded);
    content.setAttribute('aria-hidden', isExpanded);
  }

  overrideScrollBehavior() {
    const body = document.body;
    body.classList.add('-page-scrolling', 'notransition');
    this.header.classList.add('-page-scrolling');
    window.addEventListener('scroll', this.newScrollHandler.bind(this), { passive: true });
  }

  newScrollHandler() {
    const body = document.body;
    if (!body.classList.contains('-page-scrolling')) {
      body.classList.add('-page-scrolling');
    }
    if (!this.header.classList.contains('-page-scrolling')) {
      this.header.classList.add('-page-scrolling');
    }
  }

  disconnect() {
    window.removeEventListener('scroll', this.newScrollHandler);
  }
}